export default __webpack_public_path__ + "images/pyramid-gradient-blue.37116b8ab0b1e51d9b70879ee37589c2.png";